import React from 'react'
import { useTranslation } from 'react-i18next'
import LogoLoader from 'components/common/LogoLoader'
import c from './ProcessingStage.module.scss'

function ProcessingStage() {
  const { t } = useTranslation()
  return (
    <>
      <LogoLoader className={c.loader} />
      <div className="bottom">
        <p className={c.text}>{t('stages.generation.processing.loaderText')}</p>
      </div>
    </>
  )
}

export default ProcessingStage
